import './index.css';
import * as React from "react";
import {createRoot} from "react-dom/client";
import {createBrowserRouter, RouterProvider,} from "react-router-dom";
import warscrollData from './warscrollData.json'
import abilityData from './abilities.json'
import metadata from './metadata.json'
import Warscrolls from "./components/Warscrolls";
import Battlescroll from "./components/Battlescroll";
import oldWarscrollData from './old/warscrollData.json'
import oldAbilityData from './old/abilities.json'
import oldMetadata from './old/metadata.json'
import Tierlist from "./components/Tierlist";
import Tiers from "./components/Tiers";
import Plans from "./components/Plans";
import HHUsrs from "./hh/components/HHUsrs";
import usrData from "./hh/data/usrs.json";
import ScrollInput from "./components/Input";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Warscrolls warscrollData={warscrollData.sort((a, b) => a.name.localeCompare(b.name))}
                             abilityData={abilityData}
                             metadata={metadata}/>,
    }, {
        path: "/battlescroll",
        element: <Battlescroll warscrollData={warscrollData.sort((a, b) => a.name.localeCompare(b.name))}
                               prevData={oldWarscrollData.sort((a, b) => a.name.localeCompare(b.name))}/>,
    }, {
        path: "/input",
        element: <ScrollInput warscrollData={warscrollData.sort((a, b) => a.name.localeCompare(b.name))}/>,
    },

    {
        path: "/old",
        element: <Warscrolls warscrollData={oldWarscrollData.sort((a, b) => a.name.localeCompare(b.name))}
                             abilityData={oldAbilityData}
                             metadata={oldMetadata}/>,
    }, {
        path: "/tier",
        element: <Tiers warscrollData={warscrollData}/>,
    }, {
        path: "/tier/:faction",
        element: <Tierlist warscrollData={warscrollData}/>,
    },
    {
        path: '/plans',
        element: <Plans/>,
    },
    {
        path: "/hh/usrs",
        element: <HHUsrs data={usrData}/>
    }
]);

createRoot(document.getElementById("root")).render(
    <RouterProvider router={router}/>
);
